export type AlgorithmParametersRevisionIndexState = number | null;

export const initialAlgorithmParametersRevisionIndexState: AlgorithmParametersRevisionIndexState =
    null;
